import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  forwardRef,
  Output,
  EventEmitter,
  ElementRef,
  LOCALE_ID,
  Inject,
} from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { shakeDeadLeaves } from '@schoolbelle/common/object-change-tracker';

export const TranslationEditorComponentValueAccessor: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TranslationEditorComponent),
  multi: true
};
@Component({
  selector: 'app-translation-editor',
  templateUrl: './translation-editor.component.html',
  styleUrls: ['./translation-editor.component.scss'],
  providers: [
    TranslationEditorComponentValueAccessor,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TranslationEditorComponent implements OnInit {


  /**
   * value
   */
  private _value: {[lang:string]:string} = {};
  get value ():string|{[lang:string]:string} {
    if (this.lang) return this._value;
    else return this._value[this.locale_id.slice(0,2)]
  }
  set value (v:string|{[lang:string]:string}) {
    if (typeof v === 'string') {
      const lang = this.lang || this.locale_id.slice(0,2);
      this._value = {[lang]:v};
    }
    else if (v) {
      this._value =  v;
    }
    else {
      this._value = {};
    }
  }
  disabled: boolean = false;  
  
  /**
   * text
   */
  set text (v:string) {
    const lang = this.lang || this.locale_id.slice(0,2);
    const shouldUpdatd = (!this._value[lang] && v) || (this._value[lang] && !v)
    this._value[lang] = v;
    shakeDeadLeaves(this._value);
    if (shouldUpdatd) {
      this.usedLangs = this._value && Object.keys(this._value) || [];
      this.usedLangsChange.next(this.usedLangs);
    }
  }
  get text ():string {
    if (this._value) return this.lang ? this._value[this.lang] : this._value[this.locale_id.slice(0,2)]
    else return '';
  }

  protected _lang:string;
  @Input() set lang(v:string) {
    if (this._lang === v) return;
    this._lang = v;
    if (this.inited) this.cdRef.detectChanges();
  }
  get lang () {
    return this._lang;
  }
  @Input() usedLangs:string[] = [];
  @Output() usedLangsChange = new EventEmitter();  
  @Input() placeholder:string;



  
  
  constructor(
    protected elementRef:ElementRef,
    protected cdRef: ChangeDetectorRef,
    @Inject(LOCALE_ID) protected locale_id:string, 
  ) {}
  
  writeValue(value: string|{[lang:string]:string}) {
    this.value = value;
    this.usedLangs = this._value && Object.keys(this._value) || [];
    this.usedLangsChange.next(this.usedLangs);
    if (!this.cdRef['destroyed']) this.cdRef.detectChanges();
  }
  onChange = _ => {};
  onTouched = () => {};
  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  inited:boolean = false;
  ngOnInit() {
    this.inited = true;
  }
}
